import type { Chapters, TemplateParameters } from '@/lib/api/types';
import type { Chapter } from '@/lib/contexts/media-controller/util';

export function getPodcastChapterParams(
  params: TemplateParameters | undefined,
): Chapters[] {
  return params && !Array.isArray(params) && params.chapters
    ? params.chapters
    : [];
}

export function toPodcastChapters(chapters: Chapters[]): Chapter[] {
  return chapters.map(item => ({
    id: item.id,
    podcast_id: item.podcast_id,
    image_url: item.image_url,
    title: item.name,
    description: item.description,
    free_access: item.free_access,
  })) as Chapter[];
}
